<template>
    <el-dialog :visible.sync="visible" width="30%" :before-close="handleClose">
        <el-tabs v-model="activeName">
            <el-tab-pane :label="$t('Main.Create_New_Project')" name="first" style="margin-bottom: 20px;">
                <div>
                    <span style="margin-right: 8px">{{ $t('Main.Project_Name') }}</span>
                    <el-input v-model="newProjectName" style="display: inline-block;width: 300px"></el-input>
                </div>
                <div style="margin-top: 20px;margin-bottom: 20px;">
                    <span style="margin-right: 20px">{{ $t('Main.Data_Type') }}</span>
                    <el-select v-model="typeValue" :placeholder="$t('Main.Please_Select')" style="width: 300px">
                        <el-option v-for="item in $t('Main.Data_Type_Select')" :key="item" :label="item" :value="item">
                        </el-option>
                    </el-select>
                </div>
            </el-tab-pane>
            <el-tab-pane :disabled="true" :label="$t('Main.Choose_project')" name="second" style="margin-bottom: 20px;">
                <div>
                    <span style="margin-right: 20px">请选择项目</span>
                    <el-select v-model="value" placeholder="Select">
                        <el-option v-for=" item  in  projectList " :key="item" :label="item" :value="item">
                        </el-option>
                    </el-select>
                </div>
            </el-tab-pane>
            <el-button type="primary" style="background-color: #0049c8;border:none;margin-right: 20px;"
                @click="diagnoseNow">{{ $t('Main.Diagnose_Now') }}</el-button>
            <el-button disabled class="diagnose-later" @click="diagnoseLater">{{ $t('Main.Diagnose_Later') }}</el-button>
        </el-tabs>
    </el-dialog>
</template>

<script>
export default {
    name: 'DataUploadDialog',
    props: {
        isShow: {
            type: Boolean,
            required: true,
            default: false,
        },
        projectList: {
            type: Array,
            required: true,
            default: null
        },
        currentTime: {
            type: String,
            required: true,
            default: null
        }
    },
    data() {
        return {
            activeName: 'first',
            visible: false,
            defaultProjectName: '',     // 默认项目名称
            // dataType: ['Electric vehicle', 'Power Station'],
            typeValue: '',
            projectName: '',
            value: '',
            newProjectName: '',
            dataTypeFlag: Number,
            dataTypeDict: {                 // 数据类型字典，用于将数据类型字符串转为数字标识，避免 if else
                'Electric vehicle': 0,
                '电动车': 0,
                'Power Station': 1,
                '储能电站': 1
            }
        }
    },
    created() {

    },

    methods: {

        checkProject() {
            if (this.activeName == 'first') {
                if (this.newProjectName == '') {
                    this.$message.error({
                        message: this.$t('Main.请输入项目名称'),
                        type: 'warning'
                    })
                    return false
                }
                if (this.typeValue == '') {
                    this.$message.error({
                        message: this.$t('Main.请选择数据类型'),
                        type: 'warning'
                    })
                    return false
                }
                return true
            }
            if (this.activeName == 'second') {
                if (this.value == '') {
                    this.$message.error({
                        message: this.$t('Main.请选择项目'),
                        type: 'warning'
                    })
                    return false
                }
                return false
            }
        },
        handleClose() {
            this.visible = false
            this.$emit('closeDialog')
        },
        diagnoseLater() {
            if (!this.checkProject()) {
                return
            }
            this.visible = false
            this.$emit('diagnoseLater', this.newProjectName, this.typeValue)
        },
        diagnoseNow() {
            if (!this.checkProject()) {
                return
            }
            this.visible = false
            // console.log(this.newProjectName,this.typeValue)

            // 用字典
            this.dataTypeFlag = this.dataTypeDict[this.typeValue]
            this.$emit('diagnoseNow', this.newProjectName, this.dataTypeFlag)
        }
    },
    watch: {
        isShow: {
            handler(newVal) {
                this.visible = newVal
            }

        },
        // 检查newProjectName变化，不重要
        // newProjectName: {
        //     handler() {
        //         console.log('watch newProjectName')
        //         console.log(this.newProjectName)
        //         console.log(this.currentTime)
        //     }
        // },
        // 监视currentTime挂载，一旦挂载完成则赋值给newProjectName
        currentTime: {
            handler(value) {
                // console.log('watch currentTime')
                // console.log(value)
                this.newProjectName = value
            }
        }

    },
    computed: {
        // newProjectName: {
        //     get(){
        //         return this.defaultProjectName = this.currentTime
        //     },
        //     set(value) {
        //         this.defaultProjectName = value
        //     }
        // }
    }
}
</script>

<style lang="less" scoped>
/deep/ .el-tabs__active-bar.is-top {
    color: #0049c8;
}

/deep/ .el-tabs__active-bar {
    background-color: #0049c8;
}

/deep/ .el-tabs__item.is-active {
    color: #0049c8;
}

/deep/ .el-tabs__item.is-active {
    color: #0049c8;
}

// /deep/ .diagnose-later:hover {
//     color: #0049c8;
// }
</style>